import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ChevronLeft, Search, X } from "lucide-react";
import * as ella from "@/lib/ellaApi";
import { useStore } from "@/lib/store";
import { useSeo } from "@/lib/seo";
import ProductCard from "@/components/ProductCard";

export default function SearchPage() {
  const nav = useNavigate();
  const { branch } = useStore();
  const [params] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const [all, setAll] = useState([]);
  const [loading, setLoading] = useState(true);

  useSeo({
    title: q ? `Cari "${q}"` : "Cari Produk",
    description: "Cari produk frozen food Ella Froze: bakso ikan, tenggiri, surimi, seafood beku.",
    path: "/search",
  });

  useEffect(() => {
    if (!branch) return;
    setLoading(true);
    ella.getAllProducts({ branchId: branch.ID })
      .then((res) => setAll(res.status ? res.data : []))
      .finally(() => setLoading(false));
  }, [branch]);

  const results = useMemo(() => {
    const term = q.trim().toLowerCase();
    if (!term) return [];
    return all.filter((p) => p.Product.toLowerCase().includes(term));
  }, [q, all]);

  return (
    <div className="pb-24">
      <div style={{ top: "var(--app-header-height, 60px)" }} className="px-3 py-3 flex items-center gap-2 sticky bg-white z-30 border-b border-gray-100">
        <button onClick={() => nav(-1)} className="p-1 hover:bg-gray-100 rounded-full" data-testid="back-button"><ChevronLeft className="w-5 h-5" /></button>
        <div className="relative flex-1">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Cari produk..."
            className="w-full pl-9 pr-9 py-2.5 bg-gray-100 rounded-full text-sm outline-none focus:bg-gray-50 focus:ring-2 focus:ring-red-200"
            data-testid="search-input"
          />
          {q && (
            <button onClick={() => setQ("")} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>

      <div className="p-4">
        {!q ? (
          <div className="py-16 text-center text-sm text-gray-400">Ketik untuk mencari produk frozen favoritmu</div>
        ) : loading ? (
          <div className="grid grid-cols-2 gap-3">{Array.from({ length: 4 }).map((_, i) => <div key={i} className="aspect-[3/4] skeleton rounded-2xl" />)}</div>
        ) : results.length === 0 ? (
          <div className="py-16 text-center text-sm text-gray-500">Tidak ditemukan produk dengan kata kunci "{q}"</div>
        ) : (
          <>
            <p className="text-xs text-gray-500 mb-2">{results.length} produk ditemukan</p>
            <div className="grid grid-cols-2 gap-3">
              {results.map((p) => <ProductCard key={p.ProductID} product={p} />)}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
